"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../../Log/LogManager");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const Attendee_1 = require("../../RtcSession/Protocol/Attendee");
const SessionDefinition_1 = require("../../RtcSession/SessionDefinition");
const SessionTicket_1 = require("../../RtcSession/Protocol/SessionTicket");
const SessionEvent_1 = require("../../RtcSession/SessionEvent");
const FudaoDefinition_1 = require("../FudaoDefinition");
const FudaoEvent_1 = require("../FudaoEvent");
const IFudaoSessionFacade_1 = require("../IFudaoSessionFacade");
const Fudao_1 = require("../Fudao");
class FudaoSessionFacade {
    constructor(sas, eh, repo) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoSessionFacade");
        this._sessionAppService = sas;
        this._evtHub = eh;
        this._fudaoRepo = repo;
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.InvitationSent, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.InvitationReceived, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.LinkWithAttendeeWasInited, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.LinkWithAttendeeWasUp, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.LinkWithAttendeeWasDown, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.LinkWithAttendeePacketLossPercentChanged, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.SessionFailed, async (evt) => await this.OnSessionEvent(evt));
        this._sessionAppService.subscribeEventAsyncHandler(SessionEvent_1.SessionEvent.SessionTerminated, async (evt) => await this.OnSessionEvent(evt));
    }
    async RequestToStartSessionAsync(fst, creatorFudaoUser, attendeeFudaoUsers) {
        if (fst === FudaoDefinition_1.FudaoSessionType.Unknown)
            throw new IFudaoSessionFacade_1.FudaoSessionFacadeError(`Can't handle ${fst}`);
        if (attendeeFudaoUsers.length === 0)
            throw new IFudaoSessionFacade_1.FudaoSessionFacadeError(`{nameof(attendeeFudaoUsers)} should have 1+ fudaouser`);
        const creator = Attendee_1.Creator.from(creatorFudaoUser.Id, creatorFudaoUser.Name);
        const attendees = (attendeeFudaoUsers).map(fu => Attendee_1.Attendee.from(fu.Id, fu.Name));
        switch (fst) {
            case FudaoDefinition_1.FudaoSessionType.TeacherVideo:
                {
                    const st = this._sessionAppService.requestToStartCreatorVideoAllAudioSessionWith(creator, false, attendees);
                    const fudaoSession = SessionExtension.ToFudaoSession(st);
                    return fudaoSession;
                }
            case FudaoDefinition_1.FudaoSessionType.Audio:
                {
                    const st = this._sessionAppService.requestToStartAudioSessionWith(creator, false, attendees);
                    return SessionExtension.ToFudaoSession(st);
                }
            case FudaoDefinition_1.FudaoSessionType.Whiteboard:
                {
                    const st = this._sessionAppService.requestToStartShareScreenSessionWith(creator, false, attendees);
                    return SessionExtension.ToFudaoSession(st);
                }
            case FudaoDefinition_1.FudaoSessionType.Data:
                {
                    const st = this._sessionAppService.requestToStartDataSessionWith(creator, attendees);
                    return SessionExtension.ToFudaoSession(st);
                }
            default:
                {
                    //Shoult not be here.
                    return FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION;
                }
        }
    }
    async StartSessionAsync(fs, teacher, videoContainer) {
        const attendee = Attendee_1.Attendee.from(teacher.Id, teacher.Name);
        await this._sessionAppService.startSessionAsync(attendee, fs.Id, videoContainer);
    }
    async StartDataSessionAsync(fs, teacher, localDataProvider, remoteDataReceiver, ctor) {
        const attendee = Attendee_1.Attendee.from(teacher.Id, teacher.Name);
        await this._sessionAppService.startDataSessionAsync(attendee, fs.Id, localDataProvider, remoteDataReceiver, ctor);
    }
    async JoinSessionAsync(fs, student, videoContainer) {
        const attendee = Attendee_1.Attendee.from(student.Id, student.Name);
        await this._sessionAppService.joinSessionAsync(attendee, fs.Id, videoContainer);
    }
    async JoinDataSessionAsync(fs, student, localDataProvider, remoteDataReceiver, ctor) {
        const attendee = Attendee_1.Attendee.from(student.Id, student.Name);
        await this._sessionAppService.joinDataSessionAsync(attendee, fs.Id, localDataProvider, remoteDataReceiver, ctor);
    }
    async StopSessionAsync(fs, teacher) {
        const attendee = Attendee_1.Attendee.from(teacher.Id, teacher.Name);
        await this._sessionAppService.stopSessionAsync(attendee, fs.Id);
    }
    async ExitSessionAsync(fs, fudaoUser) {
        const attendee = Attendee_1.Attendee.from(fudaoUser.Id, fudaoUser.Name);
        await this._sessionAppService.exitSessionAsync(attendee, fs.Id);
    }
    SwitchSessionNextVideoSource(fs, teacher) {
        const attendee = Attendee_1.Attendee.from(teacher.Id, teacher.Name);
        this._sessionAppService.switchToSessionNextVideoSource(fs.Id, attendee);
    }
    async FindFuadoByRelatedSessionId(sessionId) {
        //找已經開始而且最後操作的SessionId符合傳進來的SessionId
        const startedFudaos = await this._fudaoRepo.FudaoOfStatusAsync(FudaoDefinition_1.Status.Started);
        const foundFudao = startedFudaos.find((fudao, index, fudaos) => (fudao.LastInvitedSessionId() === sessionId) || (fudao.DataSession.Id === sessionId));
        return foundFudao || Fudao_1.Fudao.INVALID_FUDAO;
    }
    async OnSessionEvent(evt) {
        switch (evt.name) {
            case SessionEvent_1.SessionEvent.InvitationSent:
                {
                }
                break;
            case SessionEvent_1.SessionEvent.InvitationReceived:
                {
                    const st = new SessionTicket_1.SessionTicket(evt.bodyTo());
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    // DataSession是內部連接，不需發出Event給外層知道
                    if (relatedFudao.DataSession.Id === st.id)
                        return;
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.StudentStartFudaoSessionReceivedEvent(relatedFudao.id, relatedFudaoSession);
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
            case SessionEvent_1.SessionEvent.InvitationRejected:
                {
                }
                break;
            case SessionEvent_1.SessionEvent.InvitationCanceled:
                {
                }
                break;
            case SessionEvent_1.SessionEvent.LinkWithAttendeeWasInited:
                {
                    const st = new SessionTicket_1.SessionTicket(evt.bodyTo());
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    // DataSession是內部連接，不需發出Event給外層知道
                    if (relatedFudao.DataSession.Id === st.id)
                        return;
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.FudaoSessionInitedEvent(relatedFudao.id, relatedFudaoSession);
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
            case SessionEvent_1.SessionEvent.LinkWithAttendeeWasUp:
                {
                    const st = new SessionTicket_1.SessionTicket(evt.bodyTo());
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    // DataSession是內部連接，不需發出Event給外層知道
                    if (relatedFudao.DataSession.Id === st.id)
                        return;
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.FudaoSessionStartedEvent(relatedFudao.id, relatedFudaoSession);
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
            case SessionEvent_1.SessionEvent.LinkWithAttendeeWasDown:
                {
                    //目前只處理1對1 Session，所以不需處理單人離開的狀況
                    //var sta = evt.BodyTo<Tuple<SessionTicket, Attendee>>();
                }
                break;
            case SessionEvent_1.SessionEvent.LinkWithAttendeePacketLossPercentChanged:
                {
                    const body = evt.bodyTo();
                    const st = new SessionTicket_1.SessionTicket(body.Item1);
                    const percentLoss = body.Item3;
                    const networkQuality = 1.0 - percentLoss; //把掉包率轉成網路品質
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.FudaoSessionNetworkQualityChangedEvent(relatedFudao.id, TypeScriptUtils_1.NewTuple2(relatedFudaoSession, networkQuality));
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
            case SessionEvent_1.SessionEvent.SessionFailed:
                {
                    const body = evt.bodyTo();
                    const st = new SessionTicket_1.SessionTicket(body.Item1);
                    const remoteAttendee = new Attendee_1.Attendee(body.Item2);
                    const remoteSessionStatus = body.Item3;
                    const message = body.Item4;
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    //var remoteFudaoUser = GetFudaoUser(relatedFudao, remoteAttendee);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.FudaoSessionFailedEvent(TypeScriptUtils_1.NewTuple3(relatedFudao.ToFudaoDto(), relatedFudaoSession, message));
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
            case SessionEvent_1.SessionEvent.SessionTerminated:
                {
                    const st = new SessionTicket_1.SessionTicket(evt.bodyTo());
                    const relatedFudao = await this.FindFuadoByRelatedSessionId(st.id);
                    if (relatedFudao === Fudao_1.Fudao.INVALID_FUDAO) {
                        this._logger.warn(`No related fudao with this session event=${st.id}.${evt.name}`);
                        return;
                    }
                    const relatedFudaoSession = SessionExtension.ToFudaoSession(st);
                    const translatedEvt = FudaoEvent_1.FudaoEvent.FudaoSessionEndedEvent(relatedFudao.id, relatedFudaoSession);
                    await this._evtHub.receiveEventAsync(translatedEvt);
                }
                break;
        }
    }
}
exports.FudaoSessionFacade = FudaoSessionFacade;
class SessionExtension {
    static ToFudaoSession(st) {
        if (!st.isValid())
            return FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION;
        return new FudaoDefinition_1.FudaoSession({
            Id: st.id,
            SessionType: SessionExtension.ToFudaoSessionType(st.type)
        });
    }
    static ToFudaoSessionType(st) {
        switch (st) {
            case SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio: return FudaoDefinition_1.FudaoSessionType.TeacherVideo;
            case SessionDefinition_1.SessionType.Audio: return FudaoDefinition_1.FudaoSessionType.Audio;
            case SessionDefinition_1.SessionType.SharingScreen: return FudaoDefinition_1.FudaoSessionType.Whiteboard;
            case SessionDefinition_1.SessionType.Data: return FudaoDefinition_1.FudaoSessionType.Data;
            default: return FudaoDefinition_1.FudaoSessionType.Unknown;
        }
    }
}
//# sourceMappingURL=FudaoSessionFacade.js.map